import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { validatePromotionCode } from '../../lib/commercial/PromotionApi'
import { rememberPendingPromotionCode } from '../../lib/pendingPromotionCode'

export default function PromotionAttributionCapture() {
  const location = useLocation()

  useEffect(() => {
    if (location.pathname !== '/promotions') return undefined
    const code = new URLSearchParams(location.search).get('code')
    if (!code) return undefined

    let cancelled = false
    validatePromotionCode(code)
      .then((preview) => {
        if (!cancelled && preview?.valid && preview.code) {
          rememberPendingPromotionCode(preview.code)
        }
      })
      .catch(() => {
        // The visible Promotion page owns validation errors. This component only preserves valid handoffs.
      })

    return () => {
      cancelled = true
    }
  }, [location.pathname, location.search])

  return null
}
